import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { IconAddUser } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { beginAddPeople } from '../../../invite/actions';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import { makeStyles } from 'tss-react/mui';
const INVITE_BUTTON_KEY = 'invite';
const useStyles = makeStyles()(theme => {
    return {
        inviteMargin: {
            margin: `${theme.spacing(3)} 0`,
        },
    };
});
export const InviteButton = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const notifyMode = useSelector((state) => state['features/toolbox'].buttonsWithNotifyClick?.get(INVITE_BUTTON_KEY));
    const onInvite = useCallback(() => {
        if (notifyMode) {
            APP.API.notifyToolbarButtonClicked(INVITE_BUTTON_KEY, notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY);
        }
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        sendAnalytics(createToolbarEvent(INVITE_BUTTON_KEY));
        dispatch(beginAddPeople());
    }, [dispatch, notifyMode]);
    const onAdd = () => {
        parent.postMessage("myevent", "*");
    };
    const onGroupAdd = () => {
        parent.postMessage("mygroup", "*");
    };
    const conversationType = window.conversation_type;
    const { classes: styles } = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { accessibilityLabel: t('participantsPane.actions.invite'), fullWidth: true, icon: IconAddUser, labelKey: 'participantsPane.actions.invite', onClick: onInvite, type: BUTTON_TYPES.PRIMARY }),
        React.createElement(Button, { accessibilityLabel: t('participantsPane.actions.inviteteam'), fullWidth: true, icon: IconAddUser, labelKey: 'participantsPane.actions.inviteteam', onClick: onAdd, className: styles.inviteMargin, type: BUTTON_TYPES.PRIMARY }),
        conversationType == 'group' ?
            React.createElement(Button, { accessibilityLabel: t('participantsPane.actions.inviteroom'), fullWidth: true, icon: IconAddUser, labelKey: 'participantsPane.actions.inviteroom', onClick: onGroupAdd, className: styles.inviteMargin, type: BUTTON_TYPES.PRIMARY })
            : ''));
};
